import { InfoIcon, View } from "lucide-react";

import ULThemeLogo from "@/components/ULThemeLogo.tsx";
import { useSignupIdManager } from "@/screens/signup-id/hooks/useSignupIdManager.ts";

interface SharedHeaderProps {
  manager: any;
}

export default function SharedHeader(props: SharedHeaderProps) {
  const { manager } = props;
  const { texts, locales } = manager();

  // Use locale strings with fallback to SDK texts
  const logoAltText = texts?.logoAltText || locales.header?.logoAlt;
  const needHelpText = locales?.header?.needHelp;
  const contactUsText = locales?.header?.contactUs;
  const supportLink = locales?.header?.supportLink;

  return (
    <div
      className={
        "py-4 px-5 bg-[#F4F9F7] mb-4 flex justify-between items-center"
      }
    >
      <ULThemeLogo altText={logoAltText}></ULThemeLogo>

      <div className={"flex flex-col"}>
        <span
          className={
            "font-semibold text-sm flex items-center justify-end gap-1"
          }
        >
          {needHelpText}
          <InfoIcon className={"text-primary"} size={"14"} />
        </span>
        <a href={supportLink}
           target={"_blank"}
           className={"text-sm underline"}
        >
          {contactUsText}
        </a>
      </div>
    </div>
  );
}
